import axios from "axios";
import { API_BASE_URL, CONTACT_URL } from "./constants.js";
class NotFoundError extends Error {
}
function instanceOfCreateCheckoutSessionSuccessResp(resp) {
  return resp.success === true;
}
function instanceOfPlanSettingsSuccessResp(resp) {
  return resp.success === true;
}
async function updatePlanSettings(firebaseIdToken, args) {
  const { paymentMethodId, term, plan } = args;
  try {
    const resp = await axios.post(
      `${API_BASE_URL}/planSettings`,
      {
        paymentMethodId,
        term,
        plan
      },
      {
        headers: {
          Authorization: `Bearer ${firebaseIdToken}`
        },
        timeout: 26e3
      }
    );
    return resp.data;
  } catch (e) {
    if (e.response && e.response.data && e.response.data.success === false) {
      throw new Error(`<strong>Error:</strong> ${e.response.data.error}`);
    } else {
      console.error(e);
      throw new Error(
        `Error updating subscription. Please <a href="${CONTACT_URL}">contact us</a> if problem persists.`
      );
    }
  }
}
async function createAuthToken(idToken) {
  const resp = await axios.post(
    `${API_BASE_URL}/createAuthToken`,
    {},
    {
      headers: { Authorization: `Bearer ${idToken}` },
      timeout: 1e4
    }
  );
  return resp.data;
}
async function getPlanSettings(firebaseIdToken) {
  try {
    const resp = await axios.get(
      `${API_BASE_URL}/planSettings`,
      {
        timeout: 26e3,
        headers: {
          Authorization: `Bearer ${firebaseIdToken}`
        }
      }
    );
    if (instanceOfPlanSettingsSuccessResp(resp.data)) {
      return resp.data;
    } else {
      throw new Error(resp.data.error);
    }
  } catch (e) {
    if (e.response) {
      if (e.response.data && e.response.data.success === false) {
        throw new Error(`<strong>Error:</strong> ${e.response.data.error}`);
      } else if (e.response.status === 404) {
        throw new NotFoundError();
      }
    }
    console.error(e);
    throw new Error(
      `Error getting subscription info. Please <a href="${CONTACT_URL}">contact us</a> if problem persists.`
    );
  }
}
async function addCardUsingCheckoutSession(firebaseIdToken, checkoutSessionId) {
  try {
    const resp = await axios.post(
      `${API_BASE_URL}/addNewCard`,
      {
        checkoutSessionId
      },
      {
        headers: {
          Authorization: `Bearer ${firebaseIdToken}`
        }
      }
    );
    return resp.data;
  } catch (e) {
    if (e.response && e.response.data && e.response.data.success === false) {
      throw new Error(`<strong>Error:</strong> ${e.response.data.error}`);
    } else {
      console.error(e);
      throw new Error(
        `Error adding card. Please <a href="${CONTACT_URL}">contact us</a> if problem persists.`
      );
    }
  }
}
async function clearSession() {
  await axios.post(
    `${API_BASE_URL}/clearSession`
  );
}
async function createCheckoutSession(firebaseIdToken, settingsPage, plan, term, coupon, telemetry) {
  try {
    const resp = await axios.post(
      `${API_BASE_URL}/createCheckoutSession`,
      { telemetry },
      {
        timeout: 26e3,
        headers: {
          Authorization: `Bearer ${firebaseIdToken}`
        },
        params: {
          term,
          plan,
          settingsPage,
          coupon
        }
      }
    );
    if (instanceOfCreateCheckoutSessionSuccessResp(resp.data)) {
      return resp.data.sessionId;
    } else {
      throw new Error(resp.data.error);
    }
  } catch (e) {
    if (e.response && e.response.data && e.response.data.success === false) {
      throw new Error(`<strong>Error:</strong> ${e.response.data.error}`);
    } else {
      console.error(e);
      throw new Error(
        `Error creating checkout. Please <a href="${CONTACT_URL}">contact us</a> if problem persists.`
      );
    }
  }
}
async function verifyCoupon(id) {
  try {
    const resp = await axios.get(
      `${API_BASE_URL}/couponCode`,
      { params: { id } }
    );
    return resp;
  } catch (e) {
    if (e.response && e.response.data && e.response.data.success === false) {
      throw new Error(`<strong>Error:</strong> ${e.response.data.error}`);
    } else {
      console.error(e);
      throw new Error(
        `Error fetching coupon code. Please <a href="${CONTACT_URL}">contact us</a> if problem persists.`
      );
    }
  }
}
export {
  NotFoundError,
  addCardUsingCheckoutSession,
  clearSession,
  createAuthToken,
  createCheckoutSession,
  getPlanSettings,
  instanceOfCreateCheckoutSessionSuccessResp,
  instanceOfPlanSettingsSuccessResp,
  updatePlanSettings,
  verifyCoupon
};
